import { PrivacyComponentdetailsItemDiv, PrivacyComponentHeroMainDiv, PrivacyComponentMainDiv } from "../../styles/privacycomponentsstyles/privacycomponentstyle"
import Footer from "../reusable/footer/footer"
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan"
import HeaderComponent from "../reusable/header/header"

const PrivacyComponent = () => {

    return (
        <PrivacyComponentMainDiv>
            <div className="header-holder">
                <HeaderComponent />
            </div>
            <PrivacyComponentHeroMainDiv>
                <div>
                    <div className="privacy-container">
                        <div className="privacy-header-container">
                            <div>
                                <div>
                                    <HeaderSpan text="Privacy Policy" />
                                </div>
                            </div>
                            <div>
                                <div className="privacy-header-text-container">
                                    <h1> privacy</h1>
                                </div>
                            </div>
                        </div>
                        <div className="privacy-body-container">
                            {data.map((item, index) => (
                                <PrivacyComponentdetailsItemDiv>
                                    <div className="privacy-left-col">
                                        <div className="">
                                            <h3>August Update</h3>
                                        </div>
                                        <div>
                                            <div className="privacy-text-wrapper ">
                                                <p>Release: v1.3</p>
                                            </div>
                                            <div className="privacy-text-wrapper ">
                                                <p>Aug 10, 2025</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="privacy-right-col">

                                        <div className="privacy-body-text-container">

                                            <div className="privacy-texts-container">
                                                <div>
                                                    <div className="privacy-detail-text-wrapper">
                                                        <h3 >ChatGPT: Better Writing</h3>
                                                    </div>
                                                </div>
                                                <div className="privacy-details-detial-wrapper">
                                                    <div className="privacy-detail-detail-wrapper">

                                                        <div className="privacy-detail-text-wrapper">
                                                            <p>
                                                                We collect data to ensure seamless interactions and personalized experiences. When you use our services, we may collect personal details such as your name, email, and phone number. Additionally, we track your interactions with our website, including the pages you visit, the device you use, and the time spent on specific sections. Cookies are also used to store preferences and enhance functionality. All data collected is handled responsibly to maintain transparency and build trust.

                                                            </p>
                                                        </div>
                                                    </div>





                                                </div>
                                            </div>

                                            <div className="privacy-texts-container">
                                                <div>
                                                    <div className="privacy-detail-text-wrapper">
                                                        <h3 >ChatGPT: Better Writing</h3>
                                                    </div>
                                                </div>
                                                <div className="privacy-details-detial-wrapper">
                                                    
                                                    
                                                    <div className="privacy-detail-detail-wrapper">

                                                        <div className="privacy-detail-text-wrapper">
                                                            <p><b>Here comes the sun </b> 
                                                            We collect data to ensure seamless interactions and personalized experiences. When you use our services, we may collect personal details such as your name, email, and phone number. Additionally, we track your interactions with our website, including the pages you visit, the device you use, and the time spent on specific sections. Cookies are also used to store preferences and enhance functionality. All data collected is handled responsibly to maintain transparency and build trust.

                                                            </p>
                                                        </div>
                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </PrivacyComponentdetailsItemDiv>
                            ))}
                        </div>
                    </div>
                </div>
            </PrivacyComponentHeroMainDiv>
            

            <div>
                <Footer />
            </div>
        </PrivacyComponentMainDiv>
    )
}

const data = ["" ]
export default PrivacyComponent